import React from 'react'
import { connect } from 'react-redux'
import { Flags } from 'react-feature-flags'
import { screenField, unScreenField } from '../actions/screen'
import { screeningCategories } from '../config'
import Checkbox from './Checkbox'
import InfoIcon from '../../img/icon-information.svg'
import SVGWrapper from './SVGWrapper'
import Accordion from './Accordion'
import { setDialog as setDialogConnect } from '../actions/navigation'

class Screen extends React.Component {
    constructor(props) {
        super(props)

        this.state = { selections: [] }
    }

    renderField = layer => {
        const { fields: selectedFields, onSelect, onDeselect, setDialog } = this.props
        const { label, field, fields, help } = layer
        const { selections } = this.state

        // Should this filter be presented as a pull-down with options?
        const isSelect = !!fields

        // If this is a pull-down, which item is selected?
        let selected = null
        if (isSelect) {
            const selectedField = fields.find(({ field: f }) => selectedFields.includes(f))
            if (selectedField) {
                selected = selectedField.field
            }
        }

        const isChecked = isSelect ? !!selected : selectedFields.includes(field)

        // If this filter is active, which value is being filtered on?
        const selectValue = isSelect
            ? isChecked
                ? selected
                : (fields.find(({ field: f }) => selections.includes(f)) || fields[0]).field
            : field

        if (fields) {
            return (
                <React.Fragment key={label}>
                    <h6 className="title is-6 is-normal">{label}</h6>
                    {help && <div className="help-text">{help}</div>}
                    {fields.map(f => this.renderField(f))}
                </React.Fragment>
            )
        }

        return (
            <div key={label} className="filter">
                <Checkbox
                    checked={isChecked}
                    additionalClasses=""
                    onClick={() => {
                        if (isChecked) {
                            onDeselect(selectValue)
                        } else {
                            onSelect(selectValue)
                        }
                    }}
                    aria-label="Checkbox to select this screen"
                />
                <h6 className="title is-6 is-normal screen-label">{label}</h6>
                {isSelect && (
                    <div className="select">
                        <select
                            value={selectValue}
                            onChange={e => {
                                if (isChecked) {
                                    onDeselect(selectValue)
                                    onSelect(e.target.value)
                                }

                                this.setState({
                                    selections: [...selections.filter(f => f !== selectValue), e.target.value]
                                })
                            }}
                        >
                            {fields.map(f => (
                                <option key={f.field} value={f.field}>
                                    {f.label}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
                <div className="icons has-text-right is-narrow">
                    <button
                        onClick={() => {
                            setDialog('layerDescription', {
                                description: layer.description,
                                title: layer.label
                            })
                        }}
                    >
                        <span className="svg-icon svg-primary-primary svg-secondary-white">
                            <SVGWrapper title="Information icon">
                                <InfoIcon width="20px" height="20px" />
                            </SVGWrapper>
                        </span>
                    </button>
                </div>
            </div>
        )
    }

    render() {
        const { setDialog } = this.props

        return (
            <div className="screen">
                <div className="content-section">
                    <h6 className="title is-6">Screen Parcels</h6>
                    <p>
                        Applying filters below narrows the parcels that show up in the map on the right. Filters are
                        cumulative: the more filters enabled, the fewer parcels will be shown.
                    </p>

                    <p>
                        <a
                            onClick={() => setDialog('error')}
                            tabIndex="0"
                            onKeyDown={e => (e.key === 'Enter' ? setDialog('error') : null)}
                        >
                            Click here to report any errors or issues.
                        </a>
                    </p>

                    <div className="filter-group">
                        <h6 className="title is-6 filter-category">{screeningCategories[0].label}</h6>
                        <div>
                            <Accordion
                                content={screeningCategories[0].fields.map(({ label, fields }) => {
                                    return {
                                        id: label,
                                        heading: <h6 className="title is-6 is-normal">{label}</h6>,
                                        count: fields.filter(layer => {
                                            const selectedFields = this.props.fields
                                            return selectedFields.includes(layer.field)
                                        }).length,
                                        body: (
                                            <div className="filters">
                                                {fields.map(field => this.renderField(field))}
                                            </div>
                                        )
                                    }
                                })}
                            />
                        </div>
                    </div>

                    <div className="filter-group">
                        <h6 className="title is-6 filter-category">{screeningCategories[1].label}</h6>
                        <div className="filters">
                            {screeningCategories[1].fields.map(field => this.renderField(field))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    ({ screen: fields }) => ({ fields }),
    dispatch => ({
        onSelect: field => dispatch(screenField(field)),
        onDeselect: field => dispatch(unScreenField(field)),
        setDialog: (dialog, modalProps) => dispatch(setDialogConnect(dialog, modalProps))
    })
)(Screen)
